import {I18nKeys} from '@multipass-i18n';
import {Container} from '@multipass-ui-components';
import * as React from 'react';

import {AppVersion} from '../../app-config';
import {useT} from '../../logic';
import {RouterLink} from './RouterLink';

const footerLinkClass = 'font-semibold text-text-secondary no-underline hover:text-brand-emphasis';

export interface PortalFooterProps {
    crossLink: 'howItWorks' | 'home';
}

export const PortalFooter: React.FunctionComponent<PortalFooterProps> = ({crossLink}: PortalFooterProps) => {
    const t = useT();
    return (
        <footer className="border-t border-border-subtle py-8 text-caption text-text-muted">
            <Container className="flex flex-wrap items-center justify-between gap-4">
                <span>{t(I18nKeys.common.footerCopyright, {appName: t(I18nKeys.common.appName)})}</span>
                <nav aria-label={t(I18nKeys.account.termsPrivacy)} className="flex gap-5">
                    {crossLink === 'howItWorks'
                        ? <RouterLink to="/how-it-works" className={footerLinkClass}>{t(I18nKeys.header.howItWorks)}</RouterLink>
                        : <RouterLink to="/" className={footerLinkClass}>{t(I18nKeys.header.home)}</RouterLink>}
                    <a href="/legal#terms" target="_blank" rel="noopener noreferrer" className={footerLinkClass}>{t(I18nKeys.common.termsOfService)}</a>
                    <a href="/legal#privacy" target="_blank" rel="noopener noreferrer" className={footerLinkClass}>{t(I18nKeys.common.privacyPolicy)}</a>
                    <span className="tabular-nums text-text-muted">{AppVersion.display}</span>
                </nav>
            </Container>
        </footer>
    );
};
